import type { LandingPageContent } from './types'

export const PHOTOVOLTAIK_ANFRAGE_ERSTELLEN: LandingPageContent = {
  slug: 'photovoltaik-anfrage-erstellen',
  lang: 'de',
  topicId: 'photovoltaik-anfrage-erstellen',
  title: 'Photovoltaik-Anfrage erstellen – kostenlos in 5 Minuten',
  metaDescription:
    'In wenigen Minuten eine anonyme Photovoltaik-Anfrage erstellen: Dachbilder hochladen, ' +
    'Handwerker geben Angebote ab, Sie entscheiden.',
  keywords: [
    'Photovoltaik Anfrage erstellen',
    'PV Anfrage stellen',
    'Solaranlage Anfrage',
    'Photovoltaik Angebot anfragen',
  ],
  eyebrow: 'In wenigen Minuten startklar',
  h1: 'Ihre Photovoltaik-Anfrage in wenigen Minuten erstellen',
  intro:
    'Statt Formulare bei mehreren Anbietern einzeln auszufüllen, stellen Sie bei Roofora eine ' +
    'einzige anonymisierte Anfrage - und mehrere Handwerksbetriebe geben darauf ein Angebot ab. Hier sehen Sie, ' +
    'was Sie dafür brauchen und was danach passiert.',
  sections: [
    { type: 'heading', text: 'Was Sie für Ihre Anfrage benötigen' },
    {
      type: 'list',
      items: [
        'Ein paar Dachbilder (Handyfotos reichen)',
        'Ein Foto Ihres Zählerschranks',
        'Dachausrichtung und -neigung, sofern bekannt',
        'Ihr ungefährer Jahresverbrauch, optional inkl. Wärmepumpe oder E-Auto',
      ],
    },
    { type: 'heading', text: 'So berechnet Roofora Ihre passende Anlagengröße' },
    {
      type: 'paragraph',
      text:
        'Aus Ihren Angaben ermittelt das System automatisch eine passende Anlagenkonfiguration - ' +
        'Größe und Leistung, abgestimmt auf Ihr Dach und Ihren Verbrauch. Sie müssen selbst keine ' +
        'technischen Vorkenntnisse mitbringen.',
    },
    { type: 'heading', text: 'Was passiert nach dem Erstellen der Anfrage?' },
    {
      type: 'paragraph',
      text:
        'Ihre Anfrage wird anonymisiert veröffentlicht - Handwerksbetriebe in Ihrer Region sehen ' +
        'Dachdaten und Verbrauch, aber keine Kontaktdaten. Sie haben 2-4 Wochen Zeit, unverbindliche ' +
        'Angebote abzugeben, die für Sie sortiert nach Preis erscheinen.',
    },
    { type: 'heading', text: 'Ihre Daten bleiben geschützt, bis Sie zustimmen' },
    {
      type: 'paragraph',
      text:
        'Erst wenn Sie einen einzelnen Handwerksbetrieb individuell freigeben, werden E-Mail und ' +
        'Telefonnummer geteilt - keine Sammelfreigabe an alle, die Interesse zeigen. Ein Konto ' +
        'brauchen Sie dafür nur mit Nutzername und Passwort, ganz ohne E-Mail-Adresse.',
    },
  ],
  primaryCta: { label: 'Anfrage jetzt kostenlos erstellen', action: 'customer' },
  secondaryCta: { label: 'Erst Anlagengröße berechnen', action: 'link', href: '/pv-rechner' },
  relatedLinks: [
    { label: 'Kostenloser PV-Rechner', href: '/pv-rechner' },
    { label: 'So funktioniert der Angebotsvergleich', href: '/pv-angebot-vergleichen' },
    { label: 'Photovoltaik Schritt für Schritt planen', href: '/photovoltaik-planen' },
    { label: 'Anfrage ganz ohne Telefonnummer oder E-Mail', href: '/photovoltaik-ohne-telefonnummer' },
  ],
}
